import React from 'react';
import { motion } from 'framer-motion';
import CategoryIcon from './CategoryIcon';
import { getCategoryStatus } from '../utils/scoreCalculator';
import styles from './CategoryCard.module.css';

export default function CategoryCard({ categoryKey, label, score }) {
  const status = getCategoryStatus(score);

  return (
    <motion.div
      className={`${styles.card} aira-card`}
      style={{ '--accent': status.color }}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className={styles.iconWrap} style={{ color: status.color, background: `${status.color}14` }}>
        <CategoryIcon categoryKey={categoryKey} size={17} />
      </div>

      <div className={styles.body}>
        <div className={styles.headerRow}>
          <span className={styles.label}>{label}</span>
          <span className={styles.percent}>{score}</span>
        </div>
        <div className={styles.track}>
          <motion.div
            className={styles.fill}
            style={{ background: status.color }}
            initial={{ width: 0 }}
            animate={{ width: `${score}%` }}
            transition={{ duration: 0.7, ease: 'easeOut', delay: 0.15 }}
          />
        </div>
        <span className={styles.status} style={{ color: status.color }}>
          {status.label}
        </span>
      </div>
    </motion.div>
  );
}
